const RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const money = (c) => '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: (c % 100 ? 2 : 0), maximumFractionDigits: 2 });

// ---- Hero load sequence ----
const hero = document.querySelector('.hero');
if (hero) {
  const startHero = () => requestAnimationFrame(() => requestAnimationFrame(() => hero.classList.add('seq')));
  startHero();
  setTimeout(() => hero.classList.add('seq'), 1400);
}

// ---- Rise on scroll (once), grouped stagger ----
const io = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (!e.isIntersecting) return;
    const el = e.target;
    const group = el.closest('[data-stagger]');
    if (group) {
      const sibs = [...group.querySelectorAll('[data-rise]')];
      el.style.transitionDelay = (Math.min(sibs.indexOf(el), 6) * 60) + 'ms';
    }
    el.classList.add('in');
    io.unobserve(el);
  });
}, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });
const riseEls = document.querySelectorAll('[data-rise]');
riseEls.forEach(el => io.observe(el));
const inView = (el) => { const r = el.getBoundingClientRect(); const vh = window.innerHeight || document.documentElement.clientHeight; return r.top < vh * 0.92 && r.bottom > 0; };
requestAnimationFrame(() => riseEls.forEach(el => { if (inView(el)) { el.classList.add('in'); io.unobserve(el); } }));
if (!('IntersectionObserver' in window)) { riseEls.forEach(el => el.classList.add('in')); }

// ---- Count-up stats ----
const cio = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (!e.isIntersecting) return;
    const el = e.target; cio.unobserve(el);
    const to = parseFloat(el.dataset.countTo); const suf = el.dataset.suffix || '';
    if (RM || isNaN(to)) { el.textContent = to + suf; el.classList.add('tallied'); return; }
    const dur = 1100, t0 = performance.now();
    const step = (t) => { const p = Math.min((t - t0) / dur, 1); const eased = 1 - Math.pow(1 - p, 3); el.textContent = Math.round(eased * to) + suf; if (p < 1) requestAnimationFrame(step); else el.classList.add('tallied'); };
    requestAnimationFrame(step);
  });
}, { threshold: 0.6 });
document.querySelectorAll('[data-count-to]').forEach(el => { if (!RM) el.textContent = '0' + (el.dataset.suffix || ''); cio.observe(el); });

// ---- Process steps activate on enter ----
const pio = new IntersectionObserver((entries) => {
  entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('active'); pio.unobserve(e.target); } });
}, { threshold: 0.5 });
document.querySelectorAll('[data-step]').forEach((el, i) => { const d = el.querySelector('.dot'); if (d) d.style.transitionDelay = (i*90)+'ms'; pio.observe(el); });

// ---- Sticky condensing header ----
const nav = document.getElementById('nav');
let ticking = false;
const onScrollFrame = () => { if (nav) nav.classList.toggle('condensed', window.scrollY > 40); ticking = false; };
window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(onScrollFrame); ticking = true; } }, { passive: true });
onScrollFrame();

// ---- Before / after slider (+ one-time draggable hint) ----
(function(){
  const ba = document.getElementById('ba');
  const handle = document.getElementById('baHandle');
  if (!ba) return;
  let dragging = false;
  let interacted = false;
  const setPos = (pct) => { pct = Math.max(0, Math.min(100, pct)); ba.style.setProperty('--pos', pct + '%'); handle.setAttribute('aria-valuenow', Math.round(pct)); };
  const fromEvent = (clientX) => { const r = ba.getBoundingClientRect(); setPos(((clientX - r.left) / r.width) * 100); };
  ba.addEventListener('pointerdown', (ev) => { interacted = true; dragging = true; handle.setPointerCapture?.(ev.pointerId); fromEvent(ev.clientX); });
  window.addEventListener('pointermove', (ev) => { if (dragging) fromEvent(ev.clientX); });
  window.addEventListener('pointerup', () => { dragging = false; });
  handle.addEventListener('keydown', (ev) => {
    interacted = true;
    const cur = parseFloat(ba.style.getPropertyValue('--pos')) || 50;
    if (ev.key === 'ArrowLeft') { setPos(cur - 4); ev.preventDefault(); }
    if (ev.key === 'ArrowRight') { setPos(cur + 4); ev.preventDefault(); }
    if (ev.key === 'Home') { setPos(0); ev.preventDefault(); }
    if (ev.key === 'End') { setPos(100); ev.preventDefault(); }
  });
  // Scroll-scrubbed reveal: the divider drifts from the "before" toward the
  // "after" as the panel crosses the viewport, until the visitor takes over.
  if (!RM) {
    let raf = 0;
    const scrub = () => {
      raf = 0;
      if (interacted) return;
      const r = ba.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const prog = Math.max(0, Math.min(1, (vh - r.top) / (vh + r.height)));
      setPos(62 - prog * 24); // 62% -> 38%
    };
    const onScroll = () => { if (!raf && !interacted) raf = requestAnimationFrame(scrub); };
    window.addEventListener('scroll', onScroll, { passive: true });
    scrub();
  } else {
    setPos(50);
  }
})();

// ---- Magnetic CTA (restrained) with press ----
if (!RM && window.matchMedia('(pointer:fine)').matches) {
  document.querySelectorAll('.magnetic').forEach(btn => {
    btn.style.transition = 'transform 200ms cubic-bezier(0.25,0.46,0.45,0.94), background 200ms, box-shadow 200ms';
    let mx = 0, my = 0, pressed = false;
    const apply = () => { btn.style.transform = `translate(${mx}px, ${my + (pressed ? 1 : 0)}px)`; };
    btn.addEventListener('mousemove', (ev) => { const r = btn.getBoundingClientRect(); mx = (ev.clientX - (r.left + r.width/2)) * 0.18; my = (ev.clientY - (r.top + r.height/2)) * 0.28; apply(); });
    btn.addEventListener('mousedown', () => { pressed = true; apply(); });
    btn.addEventListener('mouseup', () => { pressed = false; apply(); });
    btn.addEventListener('mouseleave', () => { mx = 0; my = 0; pressed = false; btn.style.transform = 'translate(0,0)'; });
  });
}

// ============ CART DRAWER + AJAX ADD ============
(function(){
  const drawer = document.getElementById('cartDrawer');
  if (!drawer) return;
  const body = drawer.querySelector('.cd__body');
  const footSub = drawer.querySelector('.cd__sub b');
  const footNote = drawer.querySelector('.cd__note');
  const foot = drawer.querySelector('.cd__foot');
  const cartLink = document.querySelector('.cart-link');
  const backdrop = document.getElementById('cdBackdrop');

  // Deposit balance is authoritative from the line item property set at add time
  // (properties[_balance], in cents). Falls back to the legacy 25%-deposit assumption
  // only for carts created before this property existed.
  const DEPOSIT_BALANCE_MULT = 3;
  const lineBalance = (it) => {
    const raw = it.properties && (it.properties._balance != null ? it.properties._balance : it.properties['_balance']);
    const cents = parseInt(raw, 10);
    if (!isNaN(cents)) return cents * (it.quantity || 1);
    return /deposit/i.test(it.variant_title || '') ? it.final_line_price * DEPOSIT_BALANCE_MULT : 0;
  };

  let lastFocus = null;
  const trap = (e) => {
    if (e.key !== 'Tab') return;
    const f = drawer.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
    else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
  };
  const open = () => {
    lastFocus = document.activeElement;
    document.body.classList.add('drawer-open');
    drawer.setAttribute('aria-hidden', 'false');
    const first = drawer.querySelector('[data-cd-close]');
    if (first) requestAnimationFrame(() => first.focus());
    document.addEventListener('keydown', trap);
  };
  const close = () => {
    document.body.classList.remove('drawer-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.removeEventListener('keydown', trap);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };

  const bumpCount = (count) => {
    let badge = cartLink && cartLink.querySelector('.cart-count');
    if (!cartLink) return;
    cartLink.classList.toggle('empty', count === 0);
    cartLink.setAttribute('aria-label', count > 0 ? 'Cart, ' + count + ' item' + (count === 1 ? '' : 's') : 'Cart');
    if (count > 0) {
      if (!badge) { badge = document.createElement('span'); badge.className = 'cart-count'; cartLink.appendChild(badge); }
      badge.textContent = count;
      if (!RM) { badge.classList.remove('bump'); void badge.offsetWidth; badge.classList.add('bump'); }
    } else if (badge) { badge.remove(); }
  };

  const render = (cart) => {
    bumpCount(cart.item_count);
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cd__empty"><p>Your cart is empty.</p></div>';
      if (foot) foot.style.display = 'none';
      return;
    }
    if (foot) foot.style.display = '';
    body.innerHTML = cart.items.map((it, i) => {
      const balCents = lineBalance(it);
      const bal = balCents > 0 ? '<div class="bal">' + money(balCents) + ' balance on completion</div>' : '';
      const opt = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="op">' + it.variant_title + '</div>' : '';
      return '<div class="cd__row"><div><div class="nm">' + it.product_title + '</div>' + opt + bal +
        '<button class="rm" data-line="' + (i + 1) + '" type="button">Remove</button></div>' +
        '<div class="pr">' + money(it.final_line_price) + '</div></div>';
    }).join('');
    footSub.textContent = money(cart.total_price);
    const depTotal = cart.items.reduce((s, it) => s + lineBalance(it), 0);
    if (footNote) footNote.textContent = depTotal > 0 ? money(depTotal) + ' balance invoiced when your site is ready and you are happy.' : 'You approve before I start. You own everything after launch.';
  };

  const refresh = () => fetch('/cart.js').then(r => r.json()).then(render);

  const flyChip = (fromEl) => {
    if (RM || !cartLink) return;
    const a = fromEl.getBoundingClientRect(), b = cartLink.getBoundingClientRect();
    const chip = document.createElement('div'); chip.className = 'fly-chip';
    chip.innerHTML = '<svg viewBox="0 0 48 54"><path d="M7 22 L24 9 L41 22" stroke="#BCA96A" stroke-width="5" fill="none" stroke-linecap="round"/><path d="M7 34 L24 21 L41 34" stroke="#8A6A2F" stroke-width="5" fill="none" stroke-linecap="round"/><path d="M7 46 L24 33 L41 46" stroke="#1C1A0F" stroke-width="5" fill="none" stroke-linecap="round"/></svg>';
    chip.style.left = (a.left + a.width / 2 - 13) + 'px'; chip.style.top = (a.top + a.height / 2 - 15) + 'px';
    chip.style.transition = 'transform 520ms cubic-bezier(0.5,0,0.2,1), opacity 520ms';
    document.body.appendChild(chip);
    requestAnimationFrame(() => { chip.style.transform = 'translate(' + (b.left + b.width / 2 - (a.left + a.width / 2)) + 'px,' + (b.top + b.height / 2 - (a.top + a.height / 2)) + 'px) scale(0.4)'; chip.style.opacity = '0.2'; });
    setTimeout(() => chip.remove(), 560);
  };

  const addToCart = (form, btn) => {
    const label = btn ? btn.innerHTML : '';
    if (btn) { btn.setAttribute('aria-busy', 'true'); }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
      .then(r => { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(() => { if (btn) { flyChip(btn); btn.classList.add('is-added'); btn.innerHTML = 'Added'; } return refresh(); })
      .then(() => { open(); if (btn) setTimeout(() => { btn.classList.remove('is-added'); btn.removeAttribute('aria-busy'); btn.innerHTML = label; }, 1400); })
      .catch(() => { if (btn) { btn.removeAttribute('aria-busy'); btn.innerHTML = label; } form.submit(); });
  };

  document.querySelectorAll('form.ajax-add').forEach(form => {
    form.addEventListener('submit', (e) => { e.preventDefault(); addToCart(form, form.querySelector('[type="submit"]')); });
  });

  body && body.addEventListener('click', (e) => {
    const rm = e.target.closest('.rm'); if (!rm) return;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: parseInt(rm.dataset.line, 10), quantity: 0 }) })
      .then(r => r.json()).then(render);
  });

  drawer.querySelectorAll('[data-cd-close]').forEach(el => el.addEventListener('click', close));
  backdrop && backdrop.addEventListener('click', close);
  window.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  if (cartLink) cartLink.addEventListener('click', (e) => { e.preventDefault(); refresh().then(open); });
  // Exposed so the /pages/build configurator can open the drawer after a batch add.
  window.UWOpenCart = () => refresh().then(open);
  refresh();
})();

// ============ ESTIMATE CALCULATOR ============
(function(){
  const root = document.querySelector('[data-calc]');
  if (!root) return;
  const dep = parseFloat(root.dataset.deposit) || 0.25;
  const totalEl = root.querySelector('[data-calc-total]');
  const todayEl = root.querySelector('[data-calc-today]');
  const balEl = root.querySelector('[data-calc-balance]');
  const calc = () => {
    let total = 0;
    const tier = root.querySelector('input[name="calc-tier"]:checked');
    if (tier) total += parseInt(tier.dataset.price, 10) || 0;
    root.querySelectorAll('input[name="calc-addon"]:checked').forEach(a => { total += parseInt(a.dataset.price, 10) || 0; });
    const cents = total * 100;
    const today = Math.round(cents * dep);
    if (totalEl) totalEl.textContent = money(cents);
    if (todayEl) todayEl.textContent = money(today);
    if (balEl) balEl.textContent = money(cents - today);
  };
  root.addEventListener('change', calc);
  calc();
})();
